/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Sports_EquipmentInputs */

const en_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports Equipment`)
};

const es_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamiento deportivo`)
};

const fr_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipements de sport`)
};

const de_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportausrüstung`)
};

const ja_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スポーツ用品`)
};

const zh_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动器材`)
};

const ar_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معدات رياضية`)
};

const id_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peralatan Olahraga`)
};

const it_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attrezzatura Sportiva`)
};

const ru_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спорттовары`)
};

const pt_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento Esportivo`)
};

const ko_listing_category_sports_equipment = /** @type {(inputs: Listing_Category_Sports_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스포츠 용품`)
};

/**
* | output |
* | --- |
* | "Sports Equipment" |
*
* @param {Listing_Category_Sports_EquipmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_sports_equipment = /** @type {((inputs?: Listing_Category_Sports_EquipmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Sports_EquipmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_sports_equipment(inputs)
	if (locale === "es") return es_listing_category_sports_equipment(inputs)
	if (locale === "fr") return fr_listing_category_sports_equipment(inputs)
	if (locale === "de") return de_listing_category_sports_equipment(inputs)
	if (locale === "ja") return ja_listing_category_sports_equipment(inputs)
	if (locale === "zh") return zh_listing_category_sports_equipment(inputs)
	if (locale === "ar") return ar_listing_category_sports_equipment(inputs)
	if (locale === "id") return id_listing_category_sports_equipment(inputs)
	if (locale === "it") return it_listing_category_sports_equipment(inputs)
	if (locale === "ru") return ru_listing_category_sports_equipment(inputs)
	if (locale === "pt") return pt_listing_category_sports_equipment(inputs)
	return ko_listing_category_sports_equipment(inputs)
});